export type MasterLinkParams = {
    pllm_source?: string
    referrerUserId?: string
    osc?: string
}

export const createQRBaseUrl = 'https://gateway.flowcode.com/v3/codes/generator/static'